import { useEffect, useState } from 'react'

export function useOrganization() {
    const [subDomain, setSubDomain] = useState<string | null>(null)
    const [organization, setOrganization] = useState<{ name: string; url: string } | null>(null)

    useEffect(() => {
        const hostname = window.location.hostname
        const subdomain = hostname.split('.')[0]
        if (subdomain === 'dann' || subdomain === 'localhost' || subdomain === 'www' || subdomain === 'dann-frontend') {
            setSubDomain('default')
        } else {
            setSubDomain(subdomain)
        }
    }, [])

    useEffect(() => {
        if (subDomain === 'default') setOrganization({ name: 'Digitale Academie', url: 'leren.dann.nl' })
        else if (subDomain === 'ruby') setOrganization({ name: 'Ruby', url: 'ruby.dann.nl' })
        else if (subDomain === 'mkb') setOrganization({ name: 'MKB Noord-Nederland', url: 'mkb.dann.nl' })
        else if (subDomain === 'demo') setOrganization({ name: 'Demo', url: 'demo.dann.nl' })
        else if (subDomain === 'hanze') setOrganization({ name: 'Hanze', url: 'hanze.dann.nl' })
        else if (subDomain === 'werkpro') setOrganization({ name: 'WerkPro', url: 'werkpro.dann.nl' })
        else if (subDomain === 'openbaaronderwijsgroningen')
            setOrganization({ name: 'Openbaar Onderwijs Groningen', url: 'openbaaronderwijsgroningen.dann.nl' })
        else {
            setOrganization({ name: 'Digitale Academie', url: 'leren.dann.nl' })
        }
    }, [subDomain])

    return { organization } as const // infers [boolean, typeof load] instead of (boolean | typeof load)[]
}
